import { register } from 'async-ops';
import { getDefaultOptions } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const SAVE_DOCUMENT_EDIT_HISTORY = 'SAVE_DOCUMENT_EDIT_HISTORY';

export interface DocumentEditChangeItem {
  changeType: string;
  deltaJson: string;
  content?: string;
  pageNumber?: number;
}

export interface SaveDocumentEditHistoryRequest {
  documentId: number;
  changes: DocumentEditChangeItem[];
}

export interface SaveDocumentEditHistoryResponse {
  saved: boolean;
  expired?: boolean;
}

const service = async (data: SaveDocumentEditHistoryRequest): Promise<SaveDocumentEditHistoryResponse> => {
  const response: any = await callMdaePublicApi({
    type: 'post',
    contentType: 'application/json',
    url: '/Api/Document/SaveDocumentEditHistory',
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: JSON.stringify(data),
  });
  return response as SaveDocumentEditHistoryResponse;
};

const mock = (): Promise<SaveDocumentEditHistoryResponse> => Promise.resolve({ saved: true });

register(SAVE_DOCUMENT_EDIT_HISTORY, service, mock);
